module.exports = __webpack_public_path__ + "img/intro-banner-1.b3957adc.png";